<template>
  <v-container :style="top_style">
        <v-layout justify-center align-center>
          <v-progress-circular indeterminate color="primary"
          :size="40"
          :width="3"
          
          ></v-progress-circular>
        </v-layout>
      </v-container>
</template>

<style>
    .loading-dialog {
   background-color: transparent; 
   opacity: 0.2;
}
</style>

<script>
  export default {
    data () {
      return {
        isMobile: false,
        top_style : 'margin-top:20%',
      }
    
    },
    watch : {
      isMobile :  function () {
        if(this.isMobile == true) {
          this.top_style = 'margin-top:35%';
          
        }
      }
      
    },
    beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
    mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },

  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 600
    }
  }
    
  }
</script>